<template>
	<g :id="id" :transform="transform" fill-rule="nonzero">
		<path
			:d="wedgePaths"
			:id="wedgeId"
			:class="wedgeClass"
		></path>
		<path
			:d="labelPaths"
			:id="labelId"
			:class="labelClass"
		></path>
	</g>
</template>

<script>
export default {
	name: "DiscWedge",
	components: {},
	props: {
		id: {
			type: String,
			default: "",
			required: true,
		},
		transform: {
			type: String,
			default: "",
			required: true,
		},
		wedgePaths: {
			type: String,
			default: "",
			required: true,
		},
		labelPaths: {
			type: String,
			default: "",
			required: true,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		highType() {
			return this.id.slice( 0, 1 );
		},
		wedgeClass() {
			return `disc-svg__${ this.highType }-wedge--${ this.isActive ? "active" : "inactive" }`;
		},
		wedgeId() {
			return `wedge-${ this.id }`;
		},
		labelClass() {
			return `disc-svg__${ this.highType }-label--${ this.isActive ? "active" : "inactive" }`;
		},
		labelId() {
			return `label-${ this.id }`;
		},
	},
	methods: {},
	watch: {},
};
</script>
